import React from "react";

function IconNotificationBell(props) {
  return (
      <div className={props.className}>
        <svg
        height={props.height}
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 270 270"
        >
        <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M10060.2 1302.34c-2.6-4.57-4.2-9.88-4.2-15.55 0-17.08 13.9-30.94 30.9-30.94 17.1 0 30.9 13.86 30.9 30.94 0 5.67-1.5 10.98-4.2 15.55a89.601 89.601 0 0134.6 21.56c16.8 16.86 26.3 39.73 26.3 63.57v27.93c0 .98 0 1.96.1 2.92.9 23.94 8.7 42.19 24.5 54.04 2.6 1.88 3.6 5.16 2.6 8.14-1 2.97-3.8 4.98-6.9 4.98h-77.3v9.05c0 16.89-13.7 30.59-30.6 30.59-16.8 0-30.5-13.7-30.5-30.59v-9.05h-77.31c-3.14 0-5.92-2.01-6.91-4.98-1-2.98.03-6.26 2.54-8.14 15.82-11.85 23.62-30.1 24.59-54.02.03-.98.05-1.96.05-2.95v-27.92c0-23.84 9.44-46.71 26.24-63.57 9.9-9.84 21.7-17.17 34.6-21.56zm42.7 183.14h-31.9v9.05c0 8.83 7.1 16.01 15.9 16.01s16-7.18 16-16.01v-9.05zm-16-173.06c-2.9.08-5.7.1-8.6.51a74.948 74.948 0 00-42.3 21.27c-14.1 14.13-22.1 33.29-22.1 53.27v31.44c-.9 21.21-6.5 38.58-16.99 51.99H10177c-10.5-13.41-16.2-30.78-17-52-.1-1.17-.1-2.34-.1-3.51v-27.92c0-19.98-7.9-39.14-22-53.27a74.948 74.948 0 00-42.3-21.27c-2.9-.41-5.8-.43-8.7-.51zm-134.4 78.02l-.42-.43c-.05-1.44-.07-2.89-.07-4.34 0-53.51 31.34-99.75 76.59-121.35l6.4 13.11c-40.41 19.23-68.41 60.49-68.41 108.24 0 1.59.03 3.19.09 4.77h-14.18zm268.9 0l.5-.43v-4.34c0-53.51-31.3-99.75-76.6-121.35l-6.4 13.11c40.5 19.23 68.4 60.49 68.4 108.24v4.77h14.1zm-123.2-91.86c3.1-2.98 5-7.16 5-11.79 0-9.02-7.3-16.36-16.3-16.36s-16.3 7.34-16.3 16.36c0 4.63 1.9 8.82 5 11.79 1.9-.28 6.6-.67 11.3-.67 4.8 0 9.5.39 11.3.67z"
            transform="matrix(1.00028 0 0 1.00271 -9954.8 -1259.25)"
        ></path>
        </svg>
    </div>
  );
}

export default IconNotificationBell;
